import { render, staticRenderFns } from "./VInventoryHeader.vue?vue&type=template&id=41d46a4e"
import script from "./VInventoryHeader.vue?vue&type=script&lang=js"
export * from "./VInventoryHeader.vue?vue&type=script&lang=js"
import style0 from "./VInventoryHeader.vue?vue&type=style&index=0&id=41d46a4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports